/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiPartner } from '../models/jofi-partner';

@Injectable({
  providedIn: 'root',
})
export class JofiContentDeliveryPartnersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation partnersDeliveryControllerFindAll
   */
  static readonly PartnersDeliveryControllerFindAllPath = '/v1/content-delivery/partners';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnersDeliveryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnersDeliveryControllerFindAll$Response(params?: {

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiPartner>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiContentDeliveryPartnersService.PartnersDeliveryControllerFindAllPath, 'get');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiPartner>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `partnersDeliveryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnersDeliveryControllerFindAll(params?: {

    /**
     * This request requires a valid API key.
     */
    'x-api-key'?: string;
    context?: HttpContext
  }
): Observable<Array<JofiPartner>> {

    return this.partnersDeliveryControllerFindAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiPartner>>) => r.body as Array<JofiPartner>)
    );
  }

}
